export const ADD_USER_NEED_ERROR = 'ADD_USER_NEED_ERROR';
export const ADD_USER_NEED_SUCCESS = 'ADD_USER_NEED_SUCCESS';
export const RESET_USER_NEED = 'RESET_USER_NEED';
export const LOADING_USER_NEED_START = 'LOADING_USER_NEED_START';
export const LOADING_USER_NEED_END = 'LOADING_USER_NEED_END';
export const GET_USER_NEED = 'GET_USER_NEED';
export const GET_USER_NEED_ERROR = 'GET_USER_NEED_ERROR';